// extracted by mini-css-extract-plugin
module.exports = {"link":"BprMk","root":"uy1jd","label":"_2tcCy","justx":"_2oH9j","circle":"_1DKhQ"};